<template>
  <a-layout-sider
    class="layout-sider"
    theme="light"
    :width="collapsed ? 64 : 280"
    :style="{
      height: 'calc(100vh - 64px)',
      left: 0,
      transition: 'width 0.25s ease'
    }"
  >
    <v-tour name="layoutTour" :steps="tourSteps" :callbacks="callbacks" :options="vueTourOptions" />
    <div class="flex flex-column justify-content-between gap-2 h-full">
      <recursive-menu
        :tourIsOn="tourIsOn"
        :selectedKeys="selectedKeys"
        :visibleRoutes="visibleRoutes"
        :hasMargin="false"
        :collapsed="collapsed"
        :isRoot="true"
      />
      <div class="sider-bottom">
          <layout-support-entry :collapsed="collapsed" />
        <div class="sider-brand cursor-pointer" :class="{ collapsed }" @click="$router.push('/').catch(() => {})">
        <img
          alt="ePeople"
          src="../../assets/logo.png"
          :height="collapsed ? '32px' : '48px'"
          :width="collapsed ? '32px' : '48px'"
        />
          <h3 class="company_name" :class="{ none: collapsed }">ePeople</h3>
          <button class="sidebar-toggle" :class="{ collapsed }" type="button" @click.stop="$emit('toggle-sidebar')">
            <a-icon width="22" height="22" :icon="collapsed ? 'carbon:side-panel-open' : 'carbon:right-panel-open'" />
          </button>
        </div>
      </div>
    </div>
  </a-layout-sider>
</template>

<script>
import { Layout } from 'ant-design-vue'
import RecursiveMenu from '../recursive-menu.vue'
import routesMixin from '@/mixins/routesMixin'
import { vueTourOptions } from '@/const'
import { createLayoutTourSteps, submenuKeysList } from './layout-tour-steps'
import LayoutSupportEntry from './layout-support-entry.vue'

export default {
  props: {
    collapsed: { type: Boolean, default: false }
  },
  components: {
    'a-layout-sider': Layout.Sider,
    'recursive-menu': RecursiveMenu,
    'layout-support-entry': LayoutSupportEntry
  },
  mixins: [routesMixin],
  data() {
    return {
      tourIsOn: false,

      openKeys: [],
      selectedKeys: [],

      tourSteps: createLayoutTourSteps(this.layoutTourBeforeStartCallback),
      callbacks: {
        onSkip: this.layoutTourFinishCallback,
        onFinish: this.layoutTourFinishCallback
      }
    }
  },
  computed: {
    currentRoute() {
      return this.$route.name || ''
    },
    vueTourOptions() {
      return vueTourOptions
    }
  },
  watch: {
    currentRoute: {
      handler() {
        this.selectedKeys = [this.currentRoute]
      },
      immediate: true
    }
  },
  methods: {
    layoutTourBeforeStartCallback() {
      return new Promise(resolve => {
        const checkCondition = () => {
          this.tourIsOn = true
          this.openKeys = [...submenuKeysList]
          resolve()
        }
        checkCondition()
      })
    },
    layoutTourFinishCallback() {
      this.tourIsOn = false
      this.openKeys = []
    }
  }
}
</script>
<style scoped>
.sider-bottom {
  display: flex;
  flex-direction: column;
}

.sider-brand {
  margin: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sider-brand.collapsed {
  flex-direction: column;
  justify-content: center;
  margin: 8px 8px 12px;
}

.sidebar-toggle {
  margin-left: auto;
  width: 36px;
  height: 36px;
  background: transparent;
  border: none;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-color);
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    color 0.2s ease;
}

.sidebar-toggle.collapsed {
  order: -1;
  margin: 0;
}

.sidebar-toggle:hover {
  color: var(--primary-color);
  border-color: var(--primary-color);
}

.company_name {
  margin: 0 !important;
  opacity: 1;
  transition:
    opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.company_name.none {
  display: none;
  opacity: 0;
  max-width: 0;
}
</style>
